// extracted by mini-css-extract-plugin
module.exports = {"dates":"DateRangeInfo_dates__915Ct"};